import React from 'react'

import styles from './ActionItem.module.scss'

const ActionItem = ({ children }) => <li className={styles.actionItem}>{children}</li>

export default ActionItem
